module.exports = __webpack_public_path__ + "static/media/bill_settlement.3428d6a1.svg";